(function () {
  function loadSwiperCSS() {
    if (document.querySelector('link[href*="swiper"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
    document.head.appendChild(link);
  }

  function initAboutSwiper() {
    if (!window.Swiper) return setTimeout(initAboutSwiper, 100);
    loadSwiperCSS();
    new Swiper('.koc-awards-slider-about', {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      autoplay: { delay: 3000, disableOnInteraction: false },
      pagination: {
        el: '.koc-awards-slider-about .swiper-pagination',
        clickable: true,
        bulletClass: 'koc-about-bullet',
        bulletActiveClass: 'koc-about-bullet-active'
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAboutSwiper);
  } else {
    initAboutSwiper();
  }
})();